import { Controller } from "stimulus";
import {removeHtmlElementClass} from "../utils/utils";

export default class extends Controller {
    handleClick() {
        removeHtmlElementClass(document, "loading_overlay", "d-none");
    }
}